var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sdr-box"},[_c('h5',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.aboutsundair[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.aboutsundairtext[_vm.getCurrentLocale])}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-733cd8bf","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/sidebar/AboutSundairBox.vue
// module id = 553
// module chunks = 0